import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TableMetaContext from 'src/utils/context/TableMetaContext';
import VisibilitySettings from 'src/components/DataGrid/VisibilitySettings';
import { isColumnHidden } from 'src/utils/form/dataGrid';

const DataGridBaseColumns = ({ children, ...rest }) => {
  const { meta, name, setColumns } = useContext(TableMetaContext);

  const columns = [];
  React.Children.map(children, child => {
    columns.push({
      ...child.props,
      label: child.props.children,
      name: child.props.name,
      order: child.props.order,
      filter: child.props.filter,
      filterType: child.props.filterType || 'text',
      filterValues: child.props.filterValues,
      filterNull: child.props.filterNull,
    });
  });

  useEffect(() => {
    if (name) {
      setColumns(columns);
    }
  }, [JSON.stringify(columns)]);
  const isStatic = rest.className.indexOf('__isStatic') !== -1;

  const [popupOpened, setPopupOpened] = useState(false);
  const onPopupOpenedChange = val => {
    setPopupOpened(val);
  };

  return (
    <div {...rest} style={{ zIndex: popupOpened ? 2 : 1, }}>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          ...child.props,
          hidden: name ? isColumnHidden(meta, index) : false,
          onPopupOpenedChange,
        });
      })}
      {name && !isStatic && (
        <VisibilitySettings
          columns={columns.map(c => c.label)}
          meta={meta}
          name={name}
        />
      )}
    </div>
  );
};

DataGridBaseColumns.propTypes = {
  children: PropTypes.any,
};

export default React.memo(DataGridBaseColumns);
